import React from "react";
import Marquee from "react-fast-marquee";

const WORDS = [
  "PATHOGEN DETECTED",
  "EXPLOSIVE DIARRHEA IMMINENT",
  "DO NOT EAT THE SALAD",
  "BIOHAZARD LEVEL 9000",
  "WASH YOUR HANDS (IT WON'T HELP)",
  "OOCYSTS SPREADING",
  "CODE BROWN",
];

export const HazardMarquee = ({ speed = 60, direction = "left" }) => {
  return (
    <div className="relative border-y-4 border-[#0a133f] hazard-tape py-1" data-testid="hazard-marquee">
      <div className="bg-[#0a133f] py-2">
        <Marquee speed={speed} direction={direction} gradient={false}>
          {WORDS.concat(WORDS).map((w, i) => (
            <span
              key={i}
              className="font-display text-lg md:text-2xl mx-6 text-[#d9b3ff] uppercase tracking-wide"
              style={{ WebkitTextStroke: "1px #0a133f" }}
            >
              {w} <span className="text-[#b026ff] mx-3">///</span>
            </span>
          ))}
        </Marquee>
      </div>
    </div>
  );
};

export default HazardMarquee;
